<template>
    <div>
        <div class="container p-5">
            <h2 class="decorativeUnderline text-uppercase text-light" v-if="editItem">Edit Cross Reference</h2>
            <h2 class="decorativeUnderline text-uppercase text-light"><span v-if="!loggedIn">Submit</span><span v-else>Add</span> Cross Reference</h2>
            <div class="card mt-4 mb-4">
                <div class="card-body" v-if="submitted == false">
                    <form name="form" @submit.prevent="handleForm">
                        <div class="mb-3">
                            <label class="form-label">Instrument ID: (<small class="cR4">required</small>)</label>
                            <input type="number" class="form-control" v-model="reference.instrumentId"
                                name="instrumentId" placeholder="ex: 1" required :disabled="editItem">
                            <div class="form-text">You can find an instrument's ID on its <a href="/instruments" class="text-secondary" target="_blank">instrument information page</a>.</div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Referenced Instrument ID: (<small class="cR4">required</small>)</label>
                            <input type="number" class="form-control" v-model="reference.referencedInstrumentId"
                                name="referencedInstrumentId" placeholder="ex: 1" required :disabled="editItem">
                            <div class="form-text">You can find an instrument's ID on its <a href="/instruments" class="text-secondary" target="_blank">instrument information page</a>.</div>
                        </div>
                        <hr>
                        <div class="row" v-if="!loggedIn">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label class="form-label">Your Name: (<small class="cR4">required</small>)</label>
                                    <input required type="text" class="form-control" v-model="reference.createdName" name="createdName"
                                        placeholder="ex: John Doe">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label class="form-label">Your Email: (<small class="cR4">required</small>)</label>
                                    <input required type="email" class="form-control" v-model="reference.createdEmail" name="createdEmail"
                                        placeholder="ex: johndoe@mail.com">
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="loggedIn && editItem">
                            <label class="form-label">Approval Status:</label>
                            <select class="form-select" aria-label="Approval Status" v-model="reference.changeApprovalStatus">
                                <option value="0">Pending Approval</option>
                                <option value="1">Approved</option>
                                <option value="-1">Denied</option>
                            </select>
                        </div>
                        <div class="mb-3" v-if="loggedIn && editItem">
                            <label class="form-label">Moderation Note:</label>
                            <textarea class="form-control" v-model="reference.approvedNote" placeholder="Any comments on the item, ex. why you may be denying it"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary">Submit</button>
                        <div class="alert alert-danger mt-3 mb-0" role="alert" v-if="message">
                            {{ message.message || message }}
                        </div>
                    </form>
                </div>
                <div class="card-body" v-if="submitted">
                    <h3>Thanks for submitting this cross reference!</h3>
                    <h4 class="cR4" v-if="reference.approvalStatus == 0"><i>Its review is now pending.</i></h4>
                    <h4 class="cR4" v-if="reference.approvalStatus == -1"><i>It was denied in review.</i></h4>
                    <p v-if="loggedIn && editItem && reference.approvedNote"><b>Moderation Note</b>: {{ reference.approvedNote }}</p>
                    <ul class="list-group mt-3">
                        <li class="list-group-item"><b>Assigned Instrument ID:</b> <a :href="'/instruments/'+reference.instrumentId" target="_blank">{{ reference.instrumentId }}</a></li>
                        <li class="list-group-item"><b>Referenced Instrument ID:</b> <a :href="'/instruments/'+reference.referencedInstrumentId" target="_blank">{{ reference.referencedInstrumentId }}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReferenceService from "../services/reference.service";
    import { useRoute } from 'vue-router';

    export default {
        name: "Submit Cross Reference",
        metaInfo() {
            return {
                title: this.title + ' | Pipe Organ Database',
                meta: [
                    {
                        property: 'og:type',
                        name: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        name: 'og:title',
                        content: this.title + ' | Pipe Organ Database'
                    },
                    {
                        property: 'og:image',
                        name: 'og:image',
                        content: 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    },
                    {
                        property: 'twitter:card',
                        name: 'twitter:card',
                        content: 'summary'
                    },
                    {
                        property: 'twitter:image',
                        name: 'twitter:image',
                        content: 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    },
                    {
                        property: 'twitter:title',
                        name: 'twitter:title',
                        content: this.title + ' | Pipe Organ Database'
                    }
                ]
            }
        },
        data() {
            return {
                reference: {instrumentId: ""},
                loading: true,
                submitted: false,
                editItem: false,
                message: "",
                title: "Submit Cross Reference"
            };
        },
        mounted() {
            if (this.$route.params.id) {
                if (!this.loggedIn) {
                    this.$router.push("/login");
                } else {
                    this.loadInitial(this.$route.params.id);
                }
            } else {
                const route = useRoute();
                for (let key in route.query) {
                    if (key in this.reference) {
                        this.reference[key] = route.query[key];
                    }
                }
            }
        },
        computed: {
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            },
        },
        methods: {
            handleForm() {
                for (let key in this.reference) {
                    if (this.reference[key] === "") {
                        this.reference[key] = null;
                    }
                }
                if (this.editItem) {
                    ReferenceService.update(this.reference.id, this.reference).then(
                        (response) => {
                            this.reference = response.data;
                            this.submitted = true;
                            this.message = "";
                        },
                        (error) => {
                            this.message =
                                (error.response && error.response.data) ||
                                error.message ||
                                error.toString();
                        }
                    );
                } else {
                    ReferenceService.create(this.reference).then(
                        (response) => {
                            this.reference = response.data;
                            this.reference.changeApprovalStatus = this.reference.approvalStatus;
                            this.submitted = true;
                            this.message = "";
                        },
                        (error) => {
                            this.message =
                                (error.response && error.response.data) ||
                                error.message ||
                                error.toString();
                        }
                    );
                }
            },
            loadInitial(id) {
                ReferenceService.get(id).then(
                    (response) => {
                        this.reference = response.data;
                        this.reference.changeApprovalStatus = this.reference.approvalStatus;
                        this.reference.modifiedName = "";
                        this.reference.modifiedEmail = "";
                        this.editItem = true;
                        this.title = 'Edit Cross Reference';
                    },
                    (error) => {
                        console.log(error);
                        if (error.response && error.response.status) {
                            this.$router.push("/" + error.response.status);
                        }
                    }
                );
            },
        },
    };
</script>